import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CmsService } from 'src/app/modules/cms/services/cms.service';
import { NetworkConfigs } from 'src/app/modules/shared/models/networks.enum';
import { ProjectService } from 'src/app/modules/shared/services/project.service';

@Component({
  selector: 'landing-site-page',
  templateUrl: './landing-site-page.component.html',
  styleUrls: ['./landing-site-page.component.scss']
})
export class LandingSitePageComponent implements OnInit, OnDestroy {
  private _destroy$: Subject<any> = new Subject();
  public isLoaded: boolean = false;
  public pageId: number;
  public network: number;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private _route: ActivatedRoute,
    private _cmsService: CmsService,
    private _projectService: ProjectService
  ) { }

  ngOnInit(): void {
    this.forceNetworkStyle();
    this._route.paramMap.pipe(takeUntil(this._destroy$)).subscribe(params => {
      const queryParams = this._route.snapshot.queryParams;
      this.network = queryParams.network;
      this.pageId = Number(params.get('id'));
      this.isLoaded = true;
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
  }


  private forceNetworkStyle(): void {
    const queryParams = this._route.snapshot.queryParams;
    const networkConfig = NetworkConfigs[Number(queryParams.network)];
    this._projectService.network = networkConfig.network;
    this._cmsService.brandConfig$.next(networkConfig);
    let bodyEl = this.document.getElementById("body-el");
    bodyEl.classList.add(networkConfig.bodyClass);
  }

}
